import { render, staticRenderFns } from "./CameraNoteDialog.vue?vue&type=template&id=40706c4b&scoped=true"
import script from "./CameraNoteDialog.vue?vue&type=script&lang=js"
export * from "./CameraNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./CameraNoteDialog.vue?vue&type=style&index=0&id=40706c4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40706c4b",
  null
  
)

export default component.exports